import { makeRequest } from 'utils/requestLogger';

export default (liveID, participationID) =>
  makeRequest(
    'put',
    `/api/live_discussions/${liveID}/participations/${participationID}/toggle-audio`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/toggleStudentParticipationAudio.js